webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(59)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  "data-v-6dc8e910",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(54)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  "data-v-4081bfc8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(64)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  "data-v-92ac3c7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(53)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(96),
  /* scopeId */
  "data-v-369d95b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(55)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  "data-v-40abb176",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(62)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  "data-v-7e51218e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(57)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  "data-v-5c9d0a82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(50)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(93),
  /* scopeId */
  "data-v-24c8dd29",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(91),
  /* scopeId */
  "data-v-0fcd93b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__capitalize__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__romanize__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slugify__ = __webpack_require__(20);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('capitalize', __WEBPACK_IMPORTED_MODULE_1__capitalize__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('romanize', __WEBPACK_IMPORTED_MODULE_2__romanize__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('slugify', __WEBPACK_IMPORTED_MODULE_3__slugify__["a" /* default */]);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HomeComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CreditsComponent__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CreditsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CreditsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SummaryComponent__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SummaryComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SummaryComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GenresComponent__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GenresComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_GenresComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AuthorsComponent__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AuthorsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_AuthorsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CharactersComponent__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CharactersComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_CharactersComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ParcoursAllComponent__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ParcoursAllComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ParcoursAllComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ParcoursIndexComponent__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ParcoursIndexComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ParcoursIndexComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ParcoursSingleComponent__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ParcoursSingleComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ParcoursSingleComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_EpigramApiComponent__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_EpigramApiComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_EpigramApiComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AuthorSingleComponent__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AuthorSingleComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_AuthorSingleComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_404Component__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_404Component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_404Component__);


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomeComponent_vue___default.a
  }, {
    path: '/accueil',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomeComponent_vue___default.a,
    name: 'home'
  }, {
    path: '/credits',
    component: __WEBPACK_IMPORTED_MODULE_3__components_CreditsComponent___default.a,
    name: 'credits'
  }, {
    path: '/sommaire',
    component: __WEBPACK_IMPORTED_MODULE_4__components_SummaryComponent___default.a,
    name: 'summary'
  }, {
    path: '/genres',
    component: __WEBPACK_IMPORTED_MODULE_5__components_GenresComponent___default.a,
    name: 'genres'
  }, {
    path: '/auteurs',
    component: __WEBPACK_IMPORTED_MODULE_6__components_AuthorsComponent___default.a,
    name: 'authors'
  }, {
    path: '/auteurs/:id',
    component: __WEBPACK_IMPORTED_MODULE_12__components_AuthorSingleComponent___default.a,
    name: 'authorSingle'
  }, {
    path: '/personnages',
    component: __WEBPACK_IMPORTED_MODULE_7__components_CharactersComponent___default.a,
    name: 'characters'
  }, {
    path: '/epigramme/:id',
    component: __WEBPACK_IMPORTED_MODULE_11__components_EpigramApiComponent___default.a,
    name: 'epigram'
  }, {
    path: '/parcours',
    component: __WEBPACK_IMPORTED_MODULE_8__components_ParcoursAllComponent___default.a,
    name: 'parcoursAll'
  }, {
    path: '/parcours/:parcoursId',
    component: __WEBPACK_IMPORTED_MODULE_9__components_ParcoursIndexComponent___default.a,
    name: 'parcoursIndex'
  }, {
    path: '/parcours/:parcoursId/:epigramIndex',
    component: __WEBPACK_IMPORTED_MODULE_10__components_ParcoursSingleComponent___default.a,
    name: 'parcoursSingle'
  }, {
    path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_13__components_404Component___default.a,
    name: 'NotFound'
  }, {
    path: '*',
    redirect: '404'
  }],
  history: false,
  type: 'hash'
}));

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dataDiscover", function() { return dataDiscover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entities", function() { return entities; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);


var dataDiscover = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource('/static/mock/discover.json');

var entities = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(global.api + 'entities');


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(56)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (num) {
  if (!+num) {
    return false;
  }
  var digits = String(+num).split('');
  var key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
  var roman;
  roman = '';
  var i = 3;
  while (i--) {
    roman = (key[+digits.pop() + i * 10] || '') + roman;
  }
  return Array(+digits.join('') + 1).join('M') + roman;
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (text) {
  if (!text) return '';

  return text.toString().toLowerCase().replace('/(é|è|ê)/g', 'e').replace('/à/g', 'a').replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__(13);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.silent = true;
global.theme = __webpack_require__(15);

global.parcoursKeywordId = 6;

var clientId = '2_2pbd2c7wctes4oogk844ckc4wsw00g04kggwkwggcg4c8sccw4';
var clientSecret = '4u08cwjiogmc0sc8ks0wscsww4wck88s08ogg0g04440o44kkk';
var grantType = 'password';
var username = 'front';
var password = 'owiowi';
global.apiAuth = 'https://anthologie.raphaelaupee.fr/oauth/v2/token?client_id=' + clientId + '&client_secret=' + clientSecret + '&grant_type=' + grantType + '&username=' + username + '&password=' + password;
global.api = 'https://anthologia.ecrituresnumeriques.ca/api/v1/';
global.filterFr = '?lang=1&';

global.languages = [];

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = '/';

global.versionLanguage = function (versions, options) {
  options = options || {};

  var prefLanguageIds = [2, 5, 1, 3, 5, 6, 10, 11, 8, 7, 4, 9];

  var greekPrefLanguageIds = [8, 7, 9, 4];
  var returnVersion = {};

  if (options.greekText) {
    prefLanguageIds = greekPrefLanguageIds;
  }

  var found = false;

  for (var i = 0; i < prefLanguageIds.length; i++) {
    for (var j = 0; j < versions.length; j++) {
      if (versions[j].id_language === prefLanguageIds[i]) {
        returnVersion = versions[j];

        found = true;
        return returnVersion;
      }
    }
    if (found) {
      return;
    }
  }

  return false;
};

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ResponsiveComponent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ResponsiveComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ResponsiveComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_MainNav__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_MainNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_partials_MainNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HomeComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_Copyright__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_partials_Copyright__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Responsive: __WEBPACK_IMPORTED_MODULE_0__components_ResponsiveComponent___default.a,
    MainNav: __WEBPACK_IMPORTED_MODULE_1__components_partials_MainNav___default.a,
    Home: __WEBPACK_IMPORTED_MODULE_2__components_HomeComponent___default.a,
    Copyright: __WEBPACK_IMPORTED_MODULE_3__components_partials_Copyright___default.a
  },
  created: function created() {
    this.$http.get(global.api + 'languages').then(function (response) {
      var languagesData = JSON.parse(response.bodyText);

      var languagesOrder = [{
        family: 'français',
        name: 'moderne'
      }, {
        family: 'français',
        name: 'littéraire'
      }, {
        family: 'français',
        name: 'littéral'
      }, {
        family: 'english',
        name: 'modern'
      }, {
        family: 'italiano',
        name: 'moderno'
      }, {
        family: 'español, castellano',
        name: 'moderno'
      }, {
        family: 'ελληνικά',
        name: 'αρχαία'
      }, {
        family: 'ελληνικά',
        name: 'ancient Cagnazzi'
      }, {
        family: 'ελληνικά',
        name: 'ancient Majorna'
      }, {
        family: 'ελληνικά',
        name: 'ancient perseus'
      }, {
        family: 'ellenika',
        name: 'ancient katerina'
      }];

      var reverseLanguagesOrder = Array.prototype.reverse.call(languagesOrder);

      reverseLanguagesOrder.forEach(function (favLanguage) {
        languagesData.forEach(function (lang, index) {
          if (lang.family === favLanguage.family) {
            if (lang.name === favLanguage.name) {
              languagesData.splice(0, 0, languagesData.splice(index, 1)[0]);
            }
          }
        });
      });

      global.languages = languagesData;
    });
  }
});

global.parseVersion = function (versions) {
  for (var i = 0; i < global.languages.length; i++) {
    for (var y = 0; y < versions.length; y++) {
      if (versions[y].id_language === global.languages[i].id_language) {
        return versions[y];
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default.a
  },
  name: 'NotFound'
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_IndexNav__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_IndexNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_IndexNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AuthorSingle',
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default.a,
    IndexNav: __WEBPACK_IMPORTED_MODULE_1__partials_IndexNav___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default.a
  },
  data: function data() {
    return {
      author: {},
      authorId: 0
    };
  },

  created: function created() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default.a.methods.show();
    self.$set(self, 'authorId', self.$route.params.id);
    self.getAuthorData();
  },
  destroyed: function destroyed() {
    this.$off();
  },
  methods: {
    versionLanguage: function versionLanguage(versions, options) {
      return global.versionLanguage(versions, options);
    },
    showPopin: function showPopin() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.manuscript-popin').fadeIn(function () {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.manuscript-popin img').addClass('big');
      }).css('display', 'flex').focus();
    },
    hidePopin: function hidePopin() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.manuscript-popin img').removeClass('big');
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.manuscript-popin').fadeOut();
    },
    getAuthorData: function getAuthorData() {
      var self = this;

      self.$http.get(global.api + 'authors/' + self.authorId).then(function (response) {
        var authorData = JSON.parse(response.bodyText);

        self.$set(this, 'author', authorData);
      }, function (err) {
        console.error('Error retrieving author', err);
      }).finally(function () {
        __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default.a.methods.hide();
      });
    },

    slugify: function slugify(text) {
      if (!text) return '';

      return text.toString().toLowerCase().replace('/[éèê]/g', 'e').replace('/à/g', 'a').replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    }
  }
});

__WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).ready(function () {
  var body = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('body');

  function onTextArrowClick(arrow) {
    var self = arrow;
    var selfDropWrapper = self.siblings('.dropdown-text-wrapper');
    var selfDropText = selfDropWrapper.children();
    var selfDropTextLength = selfDropText.length;
    var selfDropTextVisible = selfDropWrapper.children('.dropdown-text.visible');
    var selfDropTextVisibleIndex = selfDropTextVisible.index();
    self.show();
    self.siblings('.glyphicon').show();
    if (arrow.hasClass('glyphicon-chevron-left')) {
      selfDropTextVisible.hide().removeClass('visible').prev().show().addClass('visible');
      if (selfDropTextVisibleIndex === 1) {
        self.hide();
      }
    } else {
      selfDropTextVisible.hide().removeClass('visible').next().show().addClass('visible');
      if (selfDropTextVisibleIndex === selfDropTextLength - 2) {
        self.hide();
      }
    }
  }

  body.on('click', '.glyphicon-chevron-left', function () {
    onTextArrowClick(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(this));
  });

  body.on('click', '.glyphicon-chevron-right', function () {
    onTextArrowClick(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(this));
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Loader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_ProgressBar__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_ProgressBar__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_1__partials_Loader___default.a,
    ScrollProgressBar: __WEBPACK_IMPORTED_MODULE_2__partials_ProgressBar___default.a
  },
  name: 'Authors',
  data: function data() {
    return {
      dataAuthors: {}
    };
  },

  created: function created() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_1__partials_Loader___default.a.methods.show();
    });
    this.getAuthorsData();
  },
  methods: {
    getAuthorsData: function getAuthorsData() {
      var self = this;

      self.$http.get(global.api + 'authors', {
        progress: function progress() {}
      }).then(function (response) {
        var authors = JSON.parse(response.bodyText);

        function compare(a, b) {
          if (a.versions[0].name < b.versions[0].name) {
            return -1;
          }
          if (a.versions[0].name > b.versions[0].name) {
            return 1;
          }
          return 0;
        }

        self.$set(this, 'dataAuthors', authors.sort(compare));
      }, function (response) {
        console.log('Error retrieving authors', response);
      }).finally(function () {
        __WEBPACK_IMPORTED_MODULE_1__partials_Loader___default.a.methods.hide();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default.a,
    ScrollProgressBar: __WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default.a
  },
  name: 'characters',
  data: function data() {
    return {
      token: '',
      dataCharacters: {}
    };
  },

  created: function created() {
    this.getCharactersData();
  },
  methods: {
    getCharactersData: function getCharactersData() {
      var self = this;

      self.$http.get(global.api + 'keyword/family/1', {
        progress: function progress() {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.loader').fadeIn();
        }
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.loader').fadeOut();
        self.$set('dataCharacters', response.data);
      }, function (response) {
        console.log('error: ' + response);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default.a
  },
  name: 'credits',
  created: function created() {
    var count = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.team-container ul li').length;
    var romanized = this.romanize(count);

    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.team-container h4 sup').text(romanized);
  },
  methods: {
    romanize: function romanize(num) {
      if (!+num) {
        return false;
      }
      var digits = String(+num).split('');
      var key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
      var roman;
      roman = '';
      var i = 3;
      while (i--) {
        roman = (key[+digits.pop() + i * 10] || '') + roman;
      }
      return Array(+digits.join('') + 1).join('M') + roman;
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_epigram_Pagination__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_epigram_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partials_epigram_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_epigram_Translation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_epigram_Translation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_epigram_Translation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_epigram_GreekText__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_epigram_GreekText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_epigram_GreekText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_epigram_Notes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_epigram_Notes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__partials_epigram_Notes__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('numberize', function (value) {
  if (value < 10) {
    value = '0' + value;
  }
  return value;
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EpigramAPI',
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_1__partials_BackBtn___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default.a,
    Pagination: __WEBPACK_IMPORTED_MODULE_3__partials_epigram_Pagination___default.a,

    Translation: __WEBPACK_IMPORTED_MODULE_4__partials_epigram_Translation___default.a,
    GreekText: __WEBPACK_IMPORTED_MODULE_5__partials_epigram_GreekText___default.a,
    Notes: __WEBPACK_IMPORTED_MODULE_6__partials_epigram_Notes___default.a
  },
  data: function data() {
    return {
      authors: [],
      epigram: {},
      parcours: {},
      parcoursId: 0,
      epigramId: Number,
      epigramIndex: 0,
      epigramLoaded: false
    };
  },

  computed: {
    parcoursTotal: function parcoursTotal() {
      return this.parcours.entities.length;
    }
  },
  mounted: function mounted() {
    var self = this;

    $('.loader').fadeIn();

    self.epigramId = self.$route.params.id;

    self.getEpigram(self.epigramId).then(function (epigramData) {
      self.$set(self, 'epigram', epigramData);

      var incompleteAuthors = self.epigram.authors;

      incompleteAuthors.forEach(function (author) {
        self.getAuthorData(author.id_author);
      });

      self.epigramLoaded = true;
      $('.loader').fadeOut();
      self.$nextTick(function () {
        setTimeout(function () {
          $('.epigram-single').addClass('loaded');
        }, 100);
      });
    });
  },
  destroyed: function destroyed() {
    $.fancybox.destroy();
  },
  methods: {
    versionLanguage: function versionLanguage(versions, options) {
      return global.versionLanguage(versions, options);
    },
    parseVersion: function parseVersion(versions) {
      return global.parseVersion(versions);
    },

    showPopin: function showPopin() {
      $('.manuscript-popin').fadeIn(function () {
        $('.manuscript-popin img').addClass('big');
      }).css('display', 'flex').focus();
    },
    hidePopin: function hidePopin() {
      $('.manuscript-popin img').removeClass('big');
      $('.manuscript-popin').fadeOut();
    },
    getAuthorData: function getAuthorData(authorId) {
      var self = this;

      self.$http.get(global.api + 'authors/' + authorId).then(function (response) {
        var authorData = JSON.parse(response.bodyText);
        if (!self.authors) {
          self.authors = [];
        }
        self.authors.push(authorData);
      }, function (err) {
        console.error('Error retrieving author', err);
      });
    },
    getEpigram: function getEpigram(epigramId) {
      var self = this;
      return self.$http.get(global.api + 'entities/' + epigramId).then(function (response) {
        var epigramData = JSON.parse(response.bodyText);

        return epigramData;
      });
    },
    openFancybox: function openFancybox(index, event) {
      event.preventDefault();

      var fancyboxInstance = $.fancybox.open(event.currentTarget.parentElement.children, {
        hash: false,
        buttons: ['thumbs', 'close'],
        type: 'iframe',
        iframe: {
          preload: false
        },
        lang: 'fr',
        i18n: {
          fr: {
            CLOSE: 'Fermer',
            NEXT: 'Suivant',
            PREV: 'Précédent',
            ERROR: 'Le contenu demandé ne peut être affiché.<br> Veuillez réessayer plus tard.',
            PLAY_START: 'Démarrer le diaporama',
            PLAY_STOP: 'Suspendre le diaporama',
            FULL_SCREEN: 'Plein écran',
            THUMBS: 'Vignettes',
            DOWNLOAD: 'Télécharger',
            SHARE: 'Partager',
            ZOOM: 'Agrandir'
          }
        },
        beforeLoad: function beforeLoad(instance, slide) {
          var regexps = {
            https: /^https:/i,
            http: /^http:/i,
            youtube: /^https?:\/\/((www\.|m\.)?youtube\.com|youtu\.be)\/(watch\?v?=|)(.+)$/i
          };

          if (regexps.https.test(window.location.protocol)) {
            if (regexps.http.test(slide.src)) {
              console.warn('Not attempting to load unsafe HTTP content on HTTPS page; opening in new tab.');
              instance.close();
              window.open(slide.src, '_newtab');
            }
          } else {}
          if (regexps.youtube.test(slide.src)) {
            slide.src = slide.src.replace(regexps.youtube, 'https://youtube.com/embed/$4');
          }
        },
        afterClose: function afterClose() {
          $.fancybox.destroy();
        }
      });

      fancyboxInstance.jumpTo(index);
    }
  }
});

$(document).ready(function () {
  var body = $('body');

  function onTextArrowClick(arrow) {
    var self = arrow;
    var selfDropWrapper = self.siblings('.dropdown-text-wrapper');
    var selfDropText = selfDropWrapper.children();
    var selfDropTextLength = selfDropText.length;
    var selfDropTextVisible = selfDropWrapper.children('.dropdown-text.visible');
    var selfDropTextVisibleIndex = selfDropTextVisible.index();
    self.show();
    self.siblings('.glyphicon').show();
    if (arrow.hasClass('glyphicon-chevron-left')) {
      selfDropTextVisible.hide().removeClass('visible').prev().show().addClass('visible');
      if (selfDropTextVisibleIndex === 1) {
        self.hide();
      }
    } else {
      selfDropTextVisible.hide().removeClass('visible').next().show().addClass('visible');
      if (selfDropTextVisibleIndex === selfDropTextLength - 2) {
        self.hide();
      }
    }
  }

  body.on('click', '.glyphicon-chevron-left', function () {
    onTextArrowClick($(this));
  });

  body.on('click', '.glyphicon-chevron-right', function () {
    onTextArrowClick($(this));
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default.a,
    ScrollProgressBar: __WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default.a
  },
  name: 'Genres',
  data: function data() {
    return {
      token: '',
      dataAuthors: {}
    };
  },

  created: function created() {
    this.getGenresData();
  },
  methods: {
    getGenresData: function getGenresData() {
      var self = this;
      try {
        self.$http.get(global.api + 'genre', {
          progress: function progress() {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.loader').fadeIn();
          }
        }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.loader').fadeOut();
          self.$set('dataGenres', response.data);
        }, function (response) {
          console.log('error: ' + response);
        });
      } catch (err) {
        console.log('error try catch: ' + err);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_MainNav__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_MainNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_MainNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MainNav: __WEBPACK_IMPORTED_MODULE_0__partials_MainNav___default.a
  },
  name: 'home',
  data: function data() {
    return {
      data: '/static/img/home/meleagre-in-love.png',
      selectedParcours: [],
      parcoursAll: []
    };
  },

  created: function created() {
    var self = this;

    self.$nextTick(function () {
      self.loader();
      self.hide();
      self.getCurrentThemeImg();
      self.getSelectedParcours();
    });
  },
  methods: {
    versionLanguage: function versionLanguage(versions, options) {
      return global.versionLanguage(versions, options);
    },
    getSelectedParcours: function getSelectedParcours() {
      var self = this;

      if (!self.parcoursAll || !self.parcoursAll.length) {
        self.getParcoursData().then(function () {
          self.getSelectedParcours();
        });
        return;
      }

      var maxToDisplay = 8;
      for (var i = 0; i < maxToDisplay; i++) {
        var totalParcoursLen = self.parcoursAll.length;
        var random = Math.floor(Math.random() * totalParcoursLen);
        console.log('all parcours', totalParcoursLen);

        console.log('a random parcours', '(' + random + ')', self.parcoursAll[random]);

        self.selectedParcours.push(self.parcoursAll[random]);

        self.parcoursAll.splice(random, 1);
      }
    },

    getParcoursData: function getParcoursData() {
      var self = this;

      return self.$http.get(global.api + 'keywords?category=' + global.parcoursKeywordId).then(function (response) {
        var parcoursAllData = JSON.parse(response.bodyText);

        parcoursAllData.forEach(function (parcours, i) {
          if (!parcours.versions || !parcours.versions.length) {
            parcoursAllData.splice(i, 1);
          }
        });

        self.$set(this, 'parcoursAll', parcoursAllData);
      }, function (err) {
        console.error('Error retrieving parcours', err);
      });
    },
    addClass: function addClass(e) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).addClass('active');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).parent().siblings().children().removeClass('active');
    },
    slugify: function slugify(text) {
      if (!text) return '';

      return text.toString().toLowerCase().replace('/[éèê]/g', 'e').replace('/à/g', 'a').replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    },
    getCurrentThemeImg: function getCurrentThemeImg() {},
    loader: function loader() {
      setTimeout(function () {
        var homeRow = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.home-row');
        var homeSubtitle = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.home .page-subtitle-container');
        var copyright = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.copyright');

        var loaderContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.fake-loader-container');
        var loaderPercentage = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.fake-loader-percentage');
        var loaderBarContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.fake-loader-bar-container');
        var loaderBarContainerWidth = loaderBarContainer.width();
        var loaderBar = loaderBarContainer.children();
        var loaderBarHide = loaderBar.children();

        loaderBar.animate({
          width: '100%'
        }, 2000, function () {
          loaderBarHide.addClass('active');
          loaderPercentage.fadeOut(500, function () {
            loaderContainer.hide();
          });
          clearInterval(loaderInterval);
          homeSubtitle.fadeIn('2000').addClass('visible');
          copyright.fadeIn('2000');
          setTimeout(function () {
            homeRow.fadeIn(2000);
          }, 500);
        });
        var loaderInterval = setInterval(function () {
          var loaderWidth = loaderBar.width();
          var percentage = Math.round(loaderWidth / loaderBarContainerWidth * 100);
          loaderPercentage.text(percentage + '%');
        }, 100);
      }, 500);
    },
    hide: function hide() {
      var homeRow = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.home-row');
      var loaderContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.fake-loader-container');
      var homeSubtitle = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.home .page-subtitle-container');
      var copyright = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.copyright');

      homeRow.hide(0);
      loaderContainer.show().css('display', 'flex');
      homeSubtitle.hide(0);
      copyright.hide(0);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default.a,
    ScrollProgressBar: __WEBPACK_IMPORTED_MODULE_1__partials_ProgressBar___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default.a
  },
  name: 'ParcoursAll',
  data: function data() {
    return {
      parcoursAll: {}
    };
  },

  created: function created() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.loader').fadeIn();
    });
    this.getParcoursData();
  },
  methods: {
    getParcoursData: function getParcoursData() {
      var self = this;
      self.$http.get(global.api + 'keywords?category=' + global.parcoursKeywordId).then(function (response) {
        var parcoursAllData = JSON.parse(response.bodyText);

        parcoursAllData.forEach(function (parcours, i) {
          if (!parcours.versions || !parcours.versions.length) {
            parcours.versions.push({ title: 'Sans titre' });
          }
        });

        parcoursAllData.sort(function (a, b) {
          return a.entities.length < b.entities.length;
        });

        self.$set(this, 'parcoursAll', parcoursAllData);
      }, function (err) {
        console.error('Error retrieving parcours', err);
      }).finally(function () {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.loader').fadeOut();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Loader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParcoursIndex',
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_1__partials_Loader___default.a
  },
  data: function data() {
    return {
      parcours: {},
      parcoursIndex: 0,
      parcoursId: 0,
      loaded: false
    };
  },

  mounted: function mounted() {
    var self = this;

    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.loader').fadeIn();

    self.$set(self, 'epigramIndex', self.$route.params.epigramIndex);
    self.$set(self, 'parcoursId', self.$route.params.parcoursId);

    self.getParcoursData();
  },
  destroyed: function destroyed() {
    this.$off();
  },
  methods: {
    showPopin: function showPopin() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.manuscript-popin').fadeIn(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.manuscript-popin img').addClass('big');
      }).css('display', 'flex').focus();
    },
    hidePopin: function hidePopin() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.manuscript-popin img').removeClass('big');
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.manuscript-popin').fadeOut();
    },
    getParcoursData: function getParcoursData() {
      var self = this;

      self.$http.get(global.api + 'keywords/' + self.parcoursId).then(function (response) {
        var parcoursData = JSON.parse(response.bodyText);

        self.$set(this, 'parcours', parcoursData);
      }, function (err) {
        console.error('Error retrieving parcours', err);
      }).finally(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.loader').fadeOut();

        __WEBPACK_IMPORTED_MODULE_2_jquery___default()(self.$el).addClass('loaded');
      });
    }
  }
});

__WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).ready(function () {
  var body = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body');

  function onTextArrowClick(arrow) {
    var self = arrow;
    var selfDropWrapper = self.siblings('.dropdown-text-wrapper');
    var selfDropText = selfDropWrapper.children();
    var selfDropTextLength = selfDropText.length;
    var selfDropTextVisible = selfDropWrapper.children('.dropdown-text.visible');
    var selfDropTextVisibleIndex = selfDropTextVisible.index();
    self.show();
    self.siblings('.glyphicon').show();
    if (arrow.hasClass('glyphicon-chevron-left')) {
      selfDropTextVisible.hide().removeClass('visible').prev().show().addClass('visible');
      if (selfDropTextVisibleIndex === 1) {
        self.hide();
      }
    } else {
      selfDropTextVisible.hide().removeClass('visible').next().show().addClass('visible');
      if (selfDropTextVisibleIndex === selfDropTextLength - 2) {
        self.hide();
      }
    }
  }

  body.on('click', '.glyphicon-chevron-left', function () {
    onTextArrowClick(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this));
  });

  body.on('click', '.glyphicon-chevron-right', function () {
    onTextArrowClick(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this));
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_epigram_Pagination__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_epigram_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partials_epigram_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_epigram_Translation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_epigram_Translation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_epigram_Translation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_epigram_GreekText__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_epigram_GreekText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_epigram_GreekText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_epigram_Notes__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_epigram_Notes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__partials_epigram_Notes__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('numberize', function (value) {
  if (value < 10) {
    value = '0' + value;
  }
  return value;
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParcoursSingle',
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_1__partials_BackBtn___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__partials_Loader___default.a,
    Pagination: __WEBPACK_IMPORTED_MODULE_3__partials_epigram_Pagination___default.a,

    Translation: __WEBPACK_IMPORTED_MODULE_4__partials_epigram_Translation___default.a,
    GreekText: __WEBPACK_IMPORTED_MODULE_5__partials_epigram_GreekText___default.a,
    Notes: __WEBPACK_IMPORTED_MODULE_6__partials_epigram_Notes___default.a
  },
  data: function data() {
    return {
      authors: [],
      epigram: {},
      parcours: {},
      parcoursId: 0,
      epigramId: Number,
      epigramIndex: 0,
      epigramLoaded: false
    };
  },

  computed: {
    parcoursTotal: function parcoursTotal() {
      return this.parcours.entities.length;
    }
  },
  mounted: function mounted() {
    var self = this;

    $('.loader').fadeIn();

    self.parcoursId = self.$route.params.parcoursId;
    self.epigramIndex = self.$route.params.epigramIndex - 1;

    self.getParcours().then(function (parcoursData) {
      self.parcours = parcoursData;
      var epigramId;

      if (parcoursData.entities[self.epigramIndex]) {
        epigramId = parcoursData.entities[self.epigramIndex].id_entity;
        self.epigramId = epigramId;
        self.getEpigram().then(function (epigramData) {
          self.$set(self, 'epigram', epigramData);

          var incompleteAuthors = self.epigram.authors;

          incompleteAuthors.forEach(function (author) {
            self.getAuthorData(author.id_author);
          });

          self.epigramLoaded = true;
          $('.loader').fadeOut();
          self.$nextTick(function () {
            setTimeout(function () {
              $('.parcours-single').addClass('loaded');
            }, 100);
          });
        });
      } else {
        $('.loader').fadeOut();
        $('.notExist').fadeIn();

        self.epigram = {};
      }
    });
  },
  destroyed: function destroyed() {
    $.fancybox.destroy();
  },
  methods: {
    versionLanguage: function versionLanguage(versions, options) {
      return global.versionLanguage(versions, options);
    },
    parseVersion: function parseVersion(versions) {
      return global.parseVersion(versions);
    },

    showPopin: function showPopin() {
      $('.manuscript-popin').fadeIn(function () {
        $('.manuscript-popin img').addClass('big');
      }).css('display', 'flex').focus();
    },
    hidePopin: function hidePopin() {
      $('.manuscript-popin img').removeClass('big');
      $('.manuscript-popin').fadeOut();
    },
    getAuthorData: function getAuthorData(authorId) {
      var self = this;

      self.$http.get(global.api + 'authors/' + authorId).then(function (response) {
        var authorData = JSON.parse(response.bodyText);
        if (!self.authors) {
          self.authors = [];
        }
        self.authors.push(authorData);
      }, function (err) {
        console.error('Error retrieving author', err);
      });
    },
    getParcours: function getParcours() {
      var self = this;

      return self.$http.get(global.api + 'keywords/' + self.parcoursId).then(function (response) {
        var parcoursData = JSON.parse(response.bodyText);
        return parcoursData;
      }, function (err) {
        console.error('Error retrieving parcours (keyword) data', err);
        $('.loader').fadeOut();
        $('.notExist').fadeIn();
      });
    },
    getEpigram: function getEpigram() {
      var self = this;

      if (self.epigramId) {
        return self.$http.get(global.api + 'entities/' + self.epigramId).then(function (response) {
          var epigramData = JSON.parse(response.bodyText);

          return epigramData;
        }, function (err) {
          $('.loader').fadeOut();
          $('.notExist').fadeIn();
          console.error('Error retrieving epigram', err);
        });
      } else {
        self.getEpigram();
      }
    },
    openFancybox: function openFancybox(index, event) {
      event.preventDefault();

      var fancyboxInstance = $.fancybox.open(event.currentTarget.parentElement.children, {
        hash: false,
        buttons: ['thumbs', 'close'],
        type: 'iframe',
        iframe: {
          preload: false
        },
        lang: 'fr',
        i18n: {
          fr: {
            CLOSE: 'Fermer',
            NEXT: 'Suivant',
            PREV: 'Précédent',
            ERROR: 'Le contenu demandé ne peut être affiché.<br> Veuillez réessayer plus tard.',
            PLAY_START: 'Démarrer le diaporama',
            PLAY_STOP: 'Suspendre le diaporama',
            FULL_SCREEN: 'Plein écran',
            THUMBS: 'Vignettes',
            DOWNLOAD: 'Télécharger',
            SHARE: 'Partager',
            ZOOM: 'Agrandir'
          }
        },
        beforeLoad: function beforeLoad(instance, slide) {
          var regexps = {
            https: /^https:/i,
            http: /^http:/i,
            youtube: /^https?:\/\/((www\.|m\.)?youtube\.com|youtu\.be)\/(watch\?v?=|)(.+)$/i
          };

          if (regexps.https.test(window.location.protocol)) {
            if (regexps.http.test(slide.src)) {
              console.warn('Not attempting to load unsafe HTTP content on HTTPS page; opening in new tab.');
              instance.close();
              window.open(slide.src, '_newtab');
            }
          } else {}
          if (regexps.youtube.test(slide.src)) {
            slide.src = slide.src.replace(regexps.youtube, 'https://youtube.com/embed/$4');
          }
        },
        afterClose: function afterClose() {
          $.fancybox.destroy();
        }
      });

      fancyboxInstance.jumpTo(index);
    },
    prev: function prev() {
      var self = this;

      var prevIndex = self.epigramIndex;

      self.$router.push({ name: 'parcoursSingle', params: { parcoursId: self.$route.params.parcoursId, epigramIndex: prevIndex } });
    },
    next: function next() {
      var self = this;
      var nextIndex = self.epigramIndex + 2;

      self.$router.push({ name: 'parcoursSingle', params: { parcoursId: self.$route.params.parcoursId, epigramIndex: nextIndex } });
    }
  }
});

$(document).ready(function () {
  var body = $('body');

  function onTextArrowClick(arrow) {
    var self = arrow;
    var selfDropWrapper = self.siblings('.dropdown-text-wrapper');
    var selfDropText = selfDropWrapper.children();
    var selfDropTextLength = selfDropText.length;
    var selfDropTextVisible = selfDropWrapper.children('.dropdown-text.visible');
    var selfDropTextVisibleIndex = selfDropTextVisible.index();
    self.show();
    self.siblings('.glyphicon').show();
    if (arrow.hasClass('glyphicon-chevron-left')) {
      selfDropTextVisible.hide().removeClass('visible').prev().show().addClass('visible');
      if (selfDropTextVisibleIndex === 1) {
        self.hide();
      }
    } else {
      selfDropTextVisible.hide().removeClass('visible').next().show().addClass('visible');
      if (selfDropTextVisibleIndex === selfDropTextLength - 2) {
        self.hide();
      }
    }
  }

  body.on('click', '.glyphicon-chevron-left', function () {
    onTextArrowClick($(this));
  });

  body.on('click', '.glyphicon-chevron-right', function () {
    onTextArrowClick($(this));
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 34 */
/***/ (function(module, exports) {



/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_BackBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_DiscoverNav__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_DiscoverNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_DiscoverNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__partials_BackBtn___default.a,
    DiscoverNav: __WEBPACK_IMPORTED_MODULE_1__partials_DiscoverNav___default.a
  },
  name: 'summary',
  data: function data() {
    return {
      data: {}
    };
  },

  created: function created() {
    this.getCurrentThemeId();
    var self = this;
    return global.theme.dataDiscover.get().then(function (response) {
      self.$set('data', response.data.themes[0]);
    }, function (response) {
      console.log(response.status);
    });
  },
  methods: {
    getCurrentThemeId: function getCurrentThemeId() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').on('mouseenter', '.discover-list a', function () {
        var dataId = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).data('id');
        return global.theme.dataDiscover.get().then(function (response) {
          self.$set('data', response.data.themes[dataId - 1]);
        }, function (response) {
          console.log(response.status);
        });
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    onBackClick: function onBackClick(e) {
      e.preventDefault();
      window.history.back();
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      themes: {}
    };
  },
  created: function created() {
    this.getThemeData();
  },
  methods: {
    addClass: function addClass(e) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).addClass('active');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).parent().siblings().children().removeClass('active');
    },
    getThemeData: function getThemeData() {
      var self = this;
      return theme.dataDiscover.get().then(function (response) {
        var data = JSON.parse(response.bodyText);
        self.themes = data.themes;
      }, function (response) {
        console.error(response.status, response);
      });
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    listItems: {},
    itemId: 0,
    routeName: ''
  },
  created: function created() {},
  methods: {
    addClass: function addClass(e) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).addClass('active');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).parent().siblings().children().removeClass('active');
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  created: function created() {},
  destroyed: function destroyed() {
    this.$off();
  },
  methods: {
    show: function show() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loader').fadeIn();
    },
    hide: function hide() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loader').fadeOut();
    }
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      search: ''
    };
  },

  created: function created() {},
  methods: {
    onSearchFocus: function onSearchFocus() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.search-partial').fadeIn(1000).css('display', 'flex');
      setTimeout(function () {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.search-partial.scroll')[0].scrollWidth > __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.search-partial.scroll').width()) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.search-scroll-progress-bar').show();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.search-scroll-arrows').show();
        }
      }, 1000);
    },
    closeSearchPartial: function closeSearchPartial() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.search-partial').fadeOut(1000);
    },
    onResetClick: function onResetClick(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[type="search"]').val('').focus();
    }
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScrollProgressBar',
  created: function created() {
    var self = this;
    this.$nextTick(function () {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row.scroll')[0].scrollWidth > __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row.scroll').width()) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-progress-bar').show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-arrows').show();
      }
      self.onScrollProgressBar();
      self.onDotClick();
    });
  },
  methods: {
    onScrollProgressBar: function onScrollProgressBar() {
      var scroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row.scroll');
      var self = this;
      scroll.scroll(function () {
        self.scrollProgressBar();
      });
    },
    scrollProgressBar: function scrollProgressBar() {
      var scroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row.scroll');
      var max = scroll[0].scrollWidth - scroll.width();
      var value = scroll.scrollLeft();
      var percentage = value / max * 100;
      var dotIndex = Math.ceil(percentage / 10);
      if (dotIndex < 1) dotIndex = 0;
      var dot = scroll.find('.scroll-dot');
      dot.eq(dotIndex).addClass('active');
      dot.eq(dotIndex).prevAll().addClass('active');
      dot.eq(dotIndex).nextAll().removeClass('active');
    },
    onDotClick: function onDotClick() {
      var scroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row.scroll');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', '.scroll-progress-bar .scroll-dot', function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('active');
        var thisIndex = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).index();
        var percentage = thisIndex + '0';
        var max = scroll[0].scrollWidth - scroll.width();
        var value = percentage * max / 100;
        scroll.animate({
          scrollLeft: value
        });
      });
    },
    onScrollLeftArrowClick: function onScrollLeftArrowClick() {
      var scroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row.scroll');
      var lastActiveIndex = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-progress-bar .scroll-dot.active').last().index();
      var prevIndex = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-progress-bar .scroll-dot').eq(lastActiveIndex - 1);
      prevIndex.addClass('active');
      var percentage = prevIndex.index() + '0';
      var max = scroll[0].scrollWidth - scroll.width();
      var value = percentage * max / 100;
      scroll.animate({
        scrollLeft: value
      });
    },
    onScrollRightArrowClick: function onScrollRightArrowClick() {
      var scroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.row.scroll');
      var lastActiveIndex = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-progress-bar .scroll-dot.active').last().index();
      var nextIndex = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.scroll-progress-bar .scroll-dot').eq(lastActiveIndex + 1);
      nextIndex.addClass('active');
      var percentage = nextIndex.index() + '0';
      var max = scroll[0].scrollWidth - scroll.width();
      var value = percentage * max / 100;
      scroll.animate({
        scrollLeft: value
      });
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    epigram: {}
  },
  methods: {
    versionLanguage: function versionLanguage(versions, lang, fallback) {
      return global.versionLanguage(versions, lang, fallback);
    },
    parseVersions: function parseVersions(versions) {
      return global.parseVersion(versions);
    },

    onGreekDropdownClick: function onGreekDropdownClick() {
      var greekContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.greek-translation');
      var greekDropdown = greekContainer.children('.dropdown-drop');
      var greekDropdownArrow = greekContainer.children('p').children('.glyphicon');
      if (!greekContainer.hasClass('droped')) {
        greekContainer.addClass('droped');
        greekDropdownArrow.addClass('glyphicon-chevron-down').removeClass('glyphicon-chevron-right');
        greekDropdown.addClass('visible');
      } else {
        greekContainer.removeClass('droped');
        greekDropdownArrow.addClass('glyphicon-chevron-right').removeClass('glyphicon-chevron-down');
        greekContainer.children('.dropdown-drop').removeClass('visible');
      }
    },
    onGreekMuteClick: function onGreekMuteClick() {
      var controlBtn, playBtn, frenchSound, greekSound, frenchMute;
      var greekMute = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.greek-mute .glyphicon');
      var audioLength = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('audio').length - 1;
      controlBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.control');
      playBtn = controlBtn.children('.play-button');
      frenchMute = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.french-mute .glyphicon');
      greekSound = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('audio')[audioLength];
      frenchMute.removeClass('glyphicon-volume-off').addClass('glyphicon-volume-up');
      if (audioLength !== 0) {
        frenchSound = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('audio')[0];
        if (frenchSound.currentTime > 0) {
          frenchSound.pause();
          frenchSound.currentTime = 0;
          frenchSound.volume = 1;
        }
      }
      if (greekSound.paused) {
        greekSound.play();
        controlBtn.removeClass('french-sound-playing').addClass('greek-sound-playing');
        playBtn.removeClass('paused');
      } else {
        if (greekSound.volume === 1) {
          greekSound.volume = 0;
          greekMute.removeClass('glyphicon-volume-up').addClass('glyphicon-volume-off');
        } else {
          greekSound.volume = 1;
          greekMute.removeClass('glyphicon-volume-off').addClass('glyphicon-volume-up');
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    notes: []
  },
  methods: {
    onNotesDropdownClick: function onNotesDropdownClick() {
      var notesContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.notes');
      var notesDropdown = notesContainer.children('.dropdown-drop');
      var notesDropdownText = notesDropdown.find('.dropdown-text');
      var notesDropdownArrow = notesContainer.children('p').children('.glyphicon');
      var notesTextArrows = notesDropdown.find('.glyphicon');
      var notesTextArrowLeft = notesDropdown.find('.glyphicon-chevron-left');
      var notesTextArrowRight = notesDropdown.find('.glyphicon-chevron-right');
      if (!notesContainer.hasClass('droped')) {
        notesContainer.addClass('droped');
        notesDropdownArrow.addClass('glyphicon-chevron-down').removeClass('glyphicon-chevron-right');
        notesDropdown.addClass('visible');
        notesDropdownText.first().addClass('visible').fadeIn('500');
        notesTextArrowRight.show();
        notesTextArrowLeft.hide();
        if (notesDropdownText.length === 1) {
          notesTextArrowRight.hide();
        }
      } else {
        notesContainer.removeClass('droped');
        notesDropdownArrow.addClass('glyphicon-chevron-right').removeClass('glyphicon-chevron-down');
        notesDropdown.removeClass('visible');
        notesDropdownText.removeClass('visible').fadeOut('500');
        notesTextArrows.fadeOut('500');
      }
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('numberize', function (value) {
  if (typeof value === 'string') {
    value = parseInt(value);
  }

  if (value < 10) {
    value = '0' + value.toString();
  }
  return value;
});

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    total: Number,
    current: Number
  },
  computed: function computed() {
    var self = this;
    return {
      showPrev: function showPrev() {
        return self.current !== 0;
      },
      showNext: function showNext() {
        console.log('should I show next?', self.current, self.total);
        return self.current + 1 < self.total;
      }
    };
  },

  created: function created() {},
  methods: {
    prev: function prev() {
      this.$emit('prev');
    },
    next: function next() {
      this.$emit('next');
    },

    onPaginationClick: function onPaginationClick() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.notes.dropdown > p .glyphicon').addClass('glyphicon-chevron-right').removeClass('glyphicon-chevron-down');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.notes').removeClass('droped');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.notes .dropdown-drop').removeClass('visible');
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    epigram: {},
    parcoursTitle: '',
    selectedLanguage: {},
    authors: [],
    languages: []
  },
  computed: {
    availableVersions: function availableVersions() {
      var self = this;
      var returnVersions = [];

      if (self.epigram) {
        self.epigram.versions.forEach(function (version) {
          for (var i = 0; i < global.languages.length; i++) {
            if (global.languages[i].id_language === version.id_language) {
              returnVersions.push(global.languages[i]);
            }
          }
        });
      }

      return returnVersions;
    }
  },
  created: function created() {
    var self = this;

    self.languages = global.languages;

    self.setCustomLanguage(self.parseVersion(self.epigram.versions).id_language);
  },

  methods: {
    versionLanguage: function versionLanguage(versions, options) {
      return global.versionLanguage(versions, options);
    },
    parseVersion: function parseVersion(versions) {
      return global.parseVersion(versions);
    },
    customLanguageSelect: function customLanguageSelect(versions) {
      var self = this;

      if (self.selectedLanguage) {
        for (var i = 0; i < versions.length; i++) {
          if (versions[i].id_language === self.selectedLanguage.id_language) {
            return versions[i];
          }
        }

        return self.parseVersion(versions);
      } else {
        return self.parseVersion(versions);
      }
    },
    setCustomLanguage: function setCustomLanguage(languageId) {
      var self = this;
      for (var i = 0; i < self.availableVersions.length; i++) {
        if (self.availableVersions[i] === languageId) {
          self.selectedLanguage = self.availableVersions[i];
        }
      }
    },

    onFrenchMuteClick: function onFrenchMuteClick() {
      var controlBtn, playBtn, frenchSound, greekSound, greekMute;
      var frenchMute = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.french-mute .glyphicon');
      controlBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.control');
      playBtn = controlBtn.children('.play-button');
      frenchSound = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('audio')[0];
      greekSound = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('audio')[1];
      greekMute = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.greek-mute .glyphicon');
      greekMute.removeClass('glyphicon-volume-off').addClass('glyphicon-volume-up');
      if (greekSound.currentTime > 0) {
        greekSound.pause();
        greekSound.currentTime = 0;
        greekSound.volume = 1;
      }
      if (frenchSound.paused) {
        frenchSound.play();
        controlBtn.removeClass('greek-sound-playing').addClass('french-sound-playing');
        playBtn.removeClass('paused');
      } else {
        if (frenchSound.volume === 1) {
          frenchSound.volume = 0;
          frenchMute.removeClass('glyphicon-volume-up').addClass('glyphicon-volume-off');
        } else {
          frenchSound.volume = 1;
          frenchMute.removeClass('glyphicon-volume-off').addClass('glyphicon-volume-up');
        }
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(46)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(89),
  /* scopeId */
  "data-v-0663cf5d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(58)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(90),
  /* scopeId */
  "data-v-0a97666d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(65)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(108),
  /* scopeId */
  "data-v-9c05ebea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(92),
  /* scopeId */
  "data-v-13f3d75b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(112),
  /* scopeId */
  "data-v-d1f57220",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  "data-v-79a0d2e5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(66)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(109),
  /* scopeId */
  "data-v-a22b7546",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(51)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(94),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(52)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  "data-v-3046e6b8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(63)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  "data-v-7f51b701",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(61)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  "data-v-7c8537cf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(67)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(110),
  /* scopeId */
  "data-v-a8b129bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(68)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(111),
  /* scopeId */
  "data-v-c71eb4d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(70)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(113),
  /* scopeId */
  "data-v-ef158734",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11 col-md-offset-1"
  }, [_c('back-btn')], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row content-container"
  }, [_c('div', [_c('p', [_c('span', {
    staticClass: "error"
  }, [_c('span', {
    staticClass: "dash"
  }), _c('i', [_vm._v("Erreur")])]), _c('strong', [_vm._v("404")])]), _vm._v(" "), _c('p', [_vm._v("La page demandée n’existe pas")]), _vm._v(" "), _c('p', [_vm._v("οὐκ ἔστιν ἡ σελὶς ἡ διεζητημένη")])])])
}]}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authors"
  }, [_c('loader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('scroll-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "row row--all scroll"
  }, [_c('div', {
    staticClass: "col-md-11 col-md-offset-1"
  }, [_c('div', {
    staticClass: "vertical-list-container"
  }, [_c('div', {
    staticClass: "vertical-list-wrapper"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n                  Retour à l’accueil\n                ")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.dataAuthors), function(author) {
    return _c('h3', [_c('span', {
      staticClass: "bg"
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'authorSingle',
          params: {
            id: author.id_author
          }
        }
      }
    }, [_vm._v("\n                  " + _vm._s(author.versions[0].name) + " "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(author.id_author)))])])], 1)
  })], 2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v("Auteurs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("Les auteurs de"), _c('br'), _vm._v(" l'Anthologie Palatine")])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.epigram && _vm.epigram.versions) ? _c('div', {
    staticClass: "translation"
  }, [_c('div', {
    staticClass: "text-title"
  }, [_c('h2', [_c('span', {
    staticClass: "bg"
  }), _vm._v("\n        " + _vm._s(_vm.epigram.title) + "\n\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-lang"
  }, [_c('label', {
    staticClass: "text-lang__label",
    attrs: {
      "for": "selectLanguage"
    }
  }, [_vm._v("Langue : ")]), _vm._v(" "), _c('div', {
    staticClass: "text-lang__select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLanguage),
      expression: "selectedLanguage"
    }],
    attrs: {
      "id": "selectLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Sélectionnez une langue…")]), _vm._v(" "), _vm._l((_vm.availableVersions), function(language) {
    return _c('option', {
      domProps: {
        "value": language
      }
    }, [_vm._v("\n            " + _vm._s(language.family) + "\n            (" + _vm._s(language.name) + ")\n          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "text-container-top-gradient"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.customLanguageSelect(_vm.epigram.versions).text_translated)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-author"
  }, [_vm._l((_vm.authors), function(author) {
    return _c('div', [_c('span', {
      staticClass: "dash"
    }), _vm._v(" "), _c('p', [_c('router-link', {
      attrs: {
        "to": {
          name: 'authorSingle',
          params: {
            id: author.versions[0].id_author
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.customLanguageSelect(author.versions).name))])], 1)])
  }), _vm._v(" "), (!_vm.authors.length) ? _c('div', [_c('span', {
    staticClass: "dash"
  })]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "text-container-bottom-gradient"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "credits"
    }
  }, [_c('div', {
    staticClass: "credits-container-top-gradient"
  }), _vm._v(" "), _c('div', {
    staticClass: "credits-scrollable-container"
  }, [_c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v("Crédits")])]), _vm._v(" "), _c('div', {
    staticClass: "row content-container"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-1"
  }, [_c('div', {
    staticClass: "desc-container"
  }, [_c('h3', [_vm._v("Un projet collaboratif")]), _vm._v(" "), _c('q', [_vm._v("\n            La Plateforme Ouverte des Parcours d'imaginaires (la POP) propose une édition numérique collaborative de l'Anthologie Palatine (AP) dirigée par la "), _c('a', {
    attrs: {
      "href": "https://ecrituresnumeriques.ca/fr/Objets-de-recherche/"
    }
  }, [_vm._v("Chaire en Recherche du Canada sur les écritures numériques")]), _vm._v(" (CRC) et son équipe interdisciplinaire et internationale (dirigée par Marcello Vitali-Rosati) en collaboration avec Elsa Bouchard et l'équipe d'HETIC. L’Anthologie Palatine est un recueil d’épigrammes grecques dont la source remonte à l’époque hellénistique (323-30 av. J.-C) qui a dès lors exercé une influence majeure sur la littérature, de la Renaissance jusqu’à nos jours. La POP propose une visualisation des versions grecques des épigrammes de l'AP et ses traductions, leurs métadonnées (auteur, date, lieu et mots-clefs) sous la forme de parcours de lecture thématiques. L'usager est invité à collaborer à cette édition en proposant directement sur la plateforme "), _c('a', {
    attrs: {
      "href": "https://anthologia.ecrituresnumeriques.ca/home"
    }
  }, [_vm._v("Anthologia")]), _vm._v(" des liens faibles, soit en associant à l’épigramme une référence (textuelle, iconographique, musicale, cinématographique ou autre) qui témoigne de l’imaginaire collectif suggéré par l’épigramme et vient ainsi ainsi enrichir le matériel anthologique.\n\n             Sur la POP sont disponibles les versions grecques des épigrammes de l'AP et ses traductions (en français, anglais et italien), leurs métadonnées (auteur, date, lieu et mots-clefs) sous la forme de parcours de lecture thématiques. L'usager est invité à collaborer à cette édition en proposant des liens faibles, soit en associant à l’épigramme une référence (textuelle, iconographique, musicale, cinématographique ou autre) qui témoigne de l’imaginaire collectif suggéré par l’épigramme et vient ainsi ainsi enrichir le matériel anthologique. Ce projet invite donc à une appropriation d’un objet littéraire insaisissable soit à comprendre et associer l’AP avec nos propres chimères intérieures.\n\n            "), _c('br'), _c('br'), _vm._v("Pour plus d’informations, consultez le "), _c('a', {
    attrs: {
      "href": "http://anthologia-doc.ecrituresnumeriques.ca/fr_FR/"
    }
  }, [_vm._v("site web")]), _vm._v(" du projet.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-md-offset-1"
  }, [_c('div', {
    staticClass: "team-container"
  }, [_c('h4', [_c('span', {
    staticClass: "bg"
  }), _vm._v("Équipe Université de Montréal "), _c('sup')]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Marcello Vitali-Rosati")]), _vm._v(" "), _c('li', [_vm._v("Elsa Bouchard")]), _vm._v(" "), _c('li', [_vm._v("Margot Mellet")]), _vm._v(" "), _c('li', [_vm._v("Arthur Juchereau")]), _vm._v(" "), _c('li', [_vm._v("Servanne Monjour")]), _vm._v(" "), _c('li', [_vm._v("Louis-Olivier Brassard")]), _vm._v(" "), _c('li', [_vm._v("Enrico Agostini-Marchese")])]), _vm._v(" "), _c('h4', [_c('span', {
    staticClass: "bg"
  }), _vm._v("Équipe HETIC "), _c('sup')]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/milenatarriere",
      "target": "_blank"
    }
  }, [_vm._v("Miléna Tarrière : Chef de Projet"), _c('span', {
    staticClass: "dash"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://nahelmoussi.com/",
      "target": "_blank"
    }
  }, [_vm._v("Nahel Moussi : UX/UI Designer site web"), _c('span', {
    staticClass: "dash"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://raphaelaupee.fr/",
      "target": "_blank"
    }
  }, [_vm._v("Raphaël Aupée : Développeur Back"), _c('span', {
    staticClass: "dash"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://paulchagnon.fr/",
      "target": "_blank"
    }
  }, [_vm._v("Paul Chagnon : UX/UI Designer documentation et back office"), _c('span', {
    staticClass: "dash"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://valentin-crochemore.fr/",
      "target": "_blank"
    }
  }, [_vm._v("Valentin Crochemore : Développeur Front"), _c('span', {
    staticClass: "dash"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11 col-md-offset-1"
  }, [_c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("L’Université de"), _c('br'), _vm._v(" Montréal & HETIC.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "credits-container-bottom-gradient"
  })])
}]}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination-partial"
  }, [_c('div', {
    staticClass: "index"
  }, [_c('p', {
    staticClass: "total"
  }, [_vm._v("\n      " + _vm._s(_vm._f("numberize")(_vm.total)) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }), _vm._v(" "), _c('p', {
    staticClass: "current"
  }, [_vm._v("\n      " + _vm._s(_vm._f("numberize")(_vm.current + 1)) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "arrows"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current !== 0),
      expression: "current !== 0"
    }],
    on: {
      "click": _vm.prev
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current + 1 < _vm.total),
      expression: " current + 1 < total"
    }],
    on: {
      "click": _vm.next
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parcours-index"
  }, [_c('loader'), _vm._v(" "), (_vm.parcours && _vm.parcours.versions) ? _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.parcours.versions[0].title))])]), _vm._v(" "), _c('scroll-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "row scroll row--all"
  }, [_c('div', {
    staticClass: "col-md-11 col-md-offset-1"
  }, [_c('div', {
    staticClass: "vertical-list-container"
  }, [_c('div', {
    staticClass: "vertical-list-wrapper"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'parcoursAll'
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n                Retour aux parcours\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('h2', [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n                " + _vm._s(_vm.parcours.versions[0].title))])]), _vm._v(" "), _vm._l((_vm.parcours.entities), function(entity, index) {
    return _c('h3', [_c('router-link', {
      attrs: {
        "to": {
          name: 'parcoursSingle',
          params: {
            parcoursId: _vm.parcours.id_keyword,
            epigramIndex: index + 1
          }
        }
      }
    }, [_c('span', {
      staticClass: "bg"
    }), _vm._v(_vm._s(entity.title) + " "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(index + 1)))])])], 1)
  })], 2)])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notExist"
  }, [_c('p', [_vm._v("Le parcours que vous cherchez n'existe pas")]), _vm._v(" "), _c('back-btn')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parcours-single"
  }, [_c('loader'), _vm._v(" "), (_vm.epigramLoaded) ? _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.versionLanguage(_vm.parcours.versions).title))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-md-offset-1"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'parcoursIndex',
        params: {
          parcoursId: _vm.parcoursId,
          parcoursName: _vm.$route.parcoursName
        }
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n            Sommaire du parcours\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('translation', {
    attrs: {
      "epigram": _vm.epigram,
      "parcours-title": _vm.parseVersion(_vm.parcours.versions).title,
      "authors": _vm.authors
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('greek-text', {
    attrs: {
      "epigram": _vm.epigram
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-md-offset-1"
  }, [_c('notes', {
    attrs: {
      "notes": _vm.epigram.notes
    }
  }), _vm._v(" "), (_vm.epigram.imagesManuscript.length) ? _c('div', {
    staticClass: "manuscript-image"
  }, [_c('p', {
    on: {
      "click": _vm.showPopin
    }
  }, [_vm._v("Images du manuscrit")]), _vm._v(" "), _c('ul', _vm._l((_vm.epigram.imagesManuscript), function(img) {
    return _c('li', [_vm._v("\n                  " + _vm._s(img.credit) + "\n                ")])
  }))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.parcours && _vm.parcours.entities) ? _c('pagination', {
    attrs: {
      "total": _vm.parcoursTotal,
      "current": _vm.epigramIndex
    },
    on: {
      "prev": function($event) {
        _vm.prev()
      },
      "next": function($event) {
        _vm.next()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "component--carousel"
  }, [(_vm.epigram && _vm.epigram.externalRef && _vm.epigram.externalRef.length) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scroll carousel__container"
  }, [_c('article', {
    staticClass: "carousel__wrapper"
  }, _vm._l((_vm.epigram.externalRef), function(ref, index) {
    return _c('a', {
      staticClass: "carousel__item -link",
      attrs: {
        "href": ref.url,
        "data-src": ref.url,
        "data-caption": ref.title
      },
      on: {
        "click": function($event) {
          _vm.openFancybox(index, $event)
        }
      }
    }, [_vm._v("\n              " + _vm._s(ref.title) + "\n            ")])
  }))])]) : _vm._e()]), _vm._v(" "), (_vm.epigram.imagesManuscript && _vm.epigram.imagesManuscript.length) ? _c('div', {
    staticClass: "manuscript-popin",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.hidePopin,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        return _vm.hidePopin($event)
      }
    }
  }, [_c('div', {
    staticClass: "popin-cross-container",
    on: {
      "click": _vm.hidePopin
    }
  }, [_c('div', {
    staticClass: "popin-cross"
  })]), _vm._v(" "), _vm._l((_vm.epigram.imagesManuscript), function(manuscript) {
    return _c('img', {
      attrs: {
        "src": manuscript.URL,
        "alt": _vm.epigram.title
      }
    })
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notExist"
  }, [_c('p', [_vm._v("L'épigramme que vous cherchez n'existe pas")]), _vm._v(" "), _c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n        Retour à l'accueil\n      ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "carousel__header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-1"
  }, [_c('div', {
    staticClass: "text-theme"
  }, [_c('h3', [_vm._v("\n                  Références\n                ")])])])])])
}]}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row home-row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-1 left-column"
  }, [_c('div', {
    staticClass: "index-nav"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.selectedParcours), function(parcours, index) {
    return _c('li', {
      directives: [{
        name: "track-by",
        rawName: "v-track-by",
        value: (index),
        expression: "index"
      }],
      staticClass: "index-list",
      on: {
        "mouseover": _vm.addClass
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'parcoursIndex',
          params: {
            parcoursId: parcours.id_keyword
          }
        }
      }
    }, [_c('span', {
      staticClass: "dash"
    }, [_c('span', {
      staticClass: "inner-dash"
    })]), _vm._v("\n                    " + _vm._s(_vm.versionLanguage(parcours.versions).title) + "\n                    "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(index + 1)))])])], 1)
  }))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 right-column"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.data
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fake-loader-container"
  }, [_c('div', {
    staticClass: "fake-loader-percentage"
  }, [_vm._v("0%")]), _vm._v(" "), _c('div', {
    staticClass: "fake-loader-bar-container"
  }, [_c('div', {
    staticClass: "fake-loader-bar"
  }, [_c('div', {
    staticClass: "fake-loader-bar-hide"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("L’Anthologie"), _c('br'), _vm._v(" Palatine & découverte.")])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loader-bar"
  }, [_c('p', [_vm._v("Veuillez patienter s'il vous plait ...")])])])
}]}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-nav"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    },
    on: {
      "click": _vm.closeSearchPartial
    }
  }, [_c('h1', [_vm._v("Antho"), _c('span', [_vm._v("logie")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'parcoursAll'
      }
    },
    on: {
      "click": _vm.closeSearchPartial
    }
  }, [_vm._v("\n              Parcours"), _c('span', {
    staticClass: "dash"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'authors'
      }
    },
    on: {
      "click": _vm.closeSearchPartial
    }
  }, [_vm._v("\n            Auteurs"), _c('span', {
    staticClass: "dash"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'credits'
      }
    },
    on: {
      "click": _vm.closeSearchPartial
    }
  }, [_vm._v("\n            Crédits"), _c('span', {
    staticClass: "dash"
  })])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "container-fluid container-main"
  }, [_c('div', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('main-nav'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "app-view"
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)]), _vm._v(" "), _c('copyright')], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('responsive')], 1)])
},staticRenderFns: []}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notes-partial"
  }, [(_vm.notes.length) ? _c('div', {
    staticClass: "notes dropdown"
  }, [_c('p', {
    on: {
      "click": _vm.onNotesDropdownClick
    }
  }, [_vm._v("\n      Notes\n      "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-drop"
  }, [_c('div', {
    staticClass: "dropdown-text-container"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-text-wrapper"
  }, _vm._l((_vm.notes), function(note) {
    return _c('div', {
      staticClass: "dropdown-text",
      attrs: {
        "id": 'note' + note.id
      }
    }, [_c('div', {
      staticClass: "dropdown-desc"
    }, [_c('q', {
      domProps: {
        "innerHTML": _vm._s(note.title)
      }
    })])])
  })), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auteur-single"
  }, [_c('loader'), _vm._v(" "), _c('div', {
    staticClass: "page-title-container"
  }, [(_vm.author && _vm.author.versions) ? _c('h1', [_vm._v(_vm._s(_vm.versionLanguage(_vm.author.versions).name))]) : _vm._e()]), _vm._v(" "), (_vm.author && _vm.author.versions) ? _c('div', {
    staticClass: "row author-row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 column"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'authors'
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n          Voir tous les auteurs\n        ")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.versionLanguage(_vm.author.versions).name))]), _vm._v(" "), _c('p', [_vm._v("Les épigrames de cet auteur :")]), _vm._v(" "), _c('div', {
    staticClass: "overflow"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.author.entities), function(listItem, index) {
    return _c('li', {
      directives: [{
        name: "track-by",
        rawName: "v-track-by",
        value: (index),
        expression: "index"
      }],
      staticClass: "index-list",
      on: {
        "mouseover": _vm.addClass
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'epigram',
          params: {
            id: listItem.id_entity
          }
        }
      }
    }, [_c('span', {
      staticClass: "dash"
    }, [_c('span', {
      staticClass: "inner-dash"
    })]), _vm._v("\n                    " + _vm._s(listItem.title) + "\n                    "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(index + 1)))])])], 1)
  }))])])])]) : _c('div', {
    staticClass: "notExist"
  }, [_c('p', [_vm._v("L'auteur que vous cherchez n'existe pas")]), _vm._v(" "), _c('back-btn')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back-btn"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.onBackClick
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n      Retour\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "genres"
  }, [_c('loader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row scroll"
  }, [_c('scroll-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-md-offset-1"
  }, [_c('back-btn'), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "vertical-list-container"
  }, _vm._l((_vm.dataGenres), function(genre) {
    return _c('div', {
      staticClass: "vertical-list-wrapper"
    }, [_c('h3', [_c('span', {
      staticClass: "bg"
    }), _vm._v(_vm._s(genre.genre_translations[0].title) + " "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(genre.id)))])]), _vm._v(" "), _c('ul', _vm._l((genre.entities), function(epigram) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": "{ name: 'epigram', params: { id: epigram.id }}"
        }
      }, [_vm._v(_vm._s(epigram.title))])], 1)
    }))])
  }))])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v("Mots clés")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("Les mots clés de"), _c('br'), _vm._v(" l'Anthologie Palatine")])])
}]}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-1 left-column"
  }, [_c('back-btn'), _vm._v(" "), _c('discover-nav'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-md-offset-1 pull-right summary-right-column"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.data.epigrams), function(epigram) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": "{ name: 'theme', params: { theme: data.slug, themeId: data.id, id: epigram.id }}"
      }
    }, [_vm._v("\n                        " + _vm._s(epigram.title) + "\n                      ")])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "small-img-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.summaryImgUrl
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("L’Anthologie"), _c('br'), _vm._v(" Palatine & découverte.")])])
}]}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.epigram && _vm.epigram.versions) ? _c('div', {
    staticClass: "greek-text"
  }, [_c('div', {
    staticClass: "greek-translation dropdown"
  }, [_c('p', {
    on: {
      "click": _vm.onGreekDropdownClick
    }
  }, [_vm._v("\n        Texte source grec\n        "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-drop"
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.versionLanguage(_vm.epigram.versions, {
        greekText: true
      }).text_translated)
    }
  })])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "responsive"
    }
  }, [_c('h1', [_vm._v("Bienvenue sur le site de découverte de l'Anthologie Palatine")]), _vm._v(" "), _c('p', [_vm._v("Malheuresement, ce site ne peut pas être visionné sur mobile et tablette")]), _vm._v(" "), _c('p', [_vm._v("Veuillez utiliser un ordinateur pour accéder à ce site")]), _vm._v(" "), _c('p', [_vm._v("Merci et à bientôt !")])])
}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "scroll-arrows"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    on: {
      "click": _vm.onScrollLeftArrowClick
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    on: {
      "click": _vm.onScrollRightArrowClick
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scroll-progress-bar"
  }, [_c('span', {
    staticClass: "scroll-dot active"
  }), _vm._v(" "), _c('span', {
    staticClass: "scroll-dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "scroll-dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "scroll-dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "scroll-dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "scroll-dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "scroll-dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "scroll-dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "scroll-dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "scroll-dot"
  })])
}]}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "characters"
  }, [_c('loader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row scroll"
  }, [_c('scroll-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-md-offset-1"
  }, [_c('back-btn'), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "vertical-list-container"
  }, _vm._l((_vm.dataCharacters.keywords), function(character) {
    return _c('div', {
      staticClass: "vertical-list-wrapper"
    }, [_c('h3', [_c('span', {
      staticClass: "bg"
    }), _vm._v(_vm._s(character.keywords_translations[0].title) + " "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(character.keywords_translations[0].id)))])]), _vm._v(" "), _c('ul', _vm._l((character.entities), function(epigram) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": {
            path: 'epigram',
            params: {
              id: epigram.id
            }
          }
        }
      }, [_vm._v(_vm._s(epigram.title))])], 1)
    }))])
  }))])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v("Personnages")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("Les personnages de"), _c('br'), _vm._v(" l'Anthologie Palatine")])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parcours-all"
  }, [_c('loader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('scroll-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "row scroll row--all"
  }, [_c('div', {
    staticClass: "col-md-11 pull-right"
  }, [_c('div', {
    staticClass: "vertical-list-container"
  }, [_c('div', {
    staticClass: "vertical-list-wrapper"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n                    Retour à l’accueil\n                  ")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.parcoursAll), function(parcours) {
    return _c('h3', [_c('router-link', {
      attrs: {
        "to": {
          name: 'parcoursIndex',
          params: {
            parcoursId: parcours.id_keyword
          }
        }
      }
    }, [_c('span', {
      staticClass: "bg"
    }), _vm._v(_vm._s(parcours.versions[0].title) + " "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(parcours.entities.length)))])])], 1)
  })], 2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v("Parcours")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("Parcours de lecture")])])
}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.wtfpl.net/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/wtfpl-badge-2.png",
      "width": "80",
      "height": "15",
      "alt": "WTFPL"
    }
  })])])])
}]}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discover-nav"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.themes), function(theme) {
    return (theme.epigrams) ? _c('li', {
      directives: [{
        name: "track-by",
        rawName: "v-track-by",
        value: (_vm.index),
        expression: "index"
      }],
      staticClass: "discover-list",
      attrs: {
        "tag": "li"
      },
      on: {
        "mouseover": _vm.addClass
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'theme',
          params: {
            themeId: theme.id
          }
        },
        "data-id": theme.id
      }
    }, [_c('span', {
      staticClass: "dash"
    }, [_c('span', {
      staticClass: "inner-dash"
    })]), _vm._v("\n                    " + _vm._s(theme.name) + "\n                    "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(theme.id)))])])], 1) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "epigram-single"
  }, [_c('loader'), _vm._v(" "), (_vm.epigramLoaded) ? _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.epigram.title))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-md-offset-1"
  }, [_c('back-btn'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('translation', {
    attrs: {
      "epigram": _vm.epigram,
      "authors": _vm.authors
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('greek-text', {
    attrs: {
      "epigram": _vm.epigram
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-md-offset-1"
  }, [_c('notes', {
    attrs: {
      "notes": _vm.epigram.notes
    }
  }), _vm._v(" "), (_vm.epigram.imagesManuscript.length) ? _c('div', {
    staticClass: "manuscript-image"
  }, [_c('p', {
    on: {
      "click": _vm.showPopin
    }
  }, [_vm._v("Images du manuscrit")]), _vm._v(" "), _c('ul', _vm._l((_vm.epigram.imagesManuscript), function(img) {
    return _c('li', [_vm._v("\n                  " + _vm._s(img.credit) + "\n                ")])
  }))]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.parcours && _vm.parcours.entities) ? _c('pagination', {
    attrs: {
      "total": _vm.parcoursTotal,
      "current": _vm.epigramIndex
    },
    on: {
      "prev": function($event) {
        _vm.prev()
      },
      "next": function($event) {
        _vm.next()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "component--carousel"
  }, [(_vm.epigram && _vm.epigram.externalRef && _vm.epigram.externalRef.length) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scroll carousel__container"
  }, [_c('article', {
    staticClass: "carousel__wrapper"
  }, _vm._l((_vm.epigram.externalRef), function(ref, index) {
    return _c('a', {
      staticClass: "carousel__item -link",
      attrs: {
        "href": ref.url,
        "data-src": ref.url,
        "data-caption": ref.title
      },
      on: {
        "click": function($event) {
          _vm.openFancybox(index, $event)
        }
      }
    }, [_vm._v("\n              " + _vm._s(ref.title) + "\n            ")])
  }))])]) : _vm._e()]), _vm._v(" "), (_vm.epigram.imagesManuscript && _vm.epigram.imagesManuscript.length) ? _c('div', {
    staticClass: "manuscript-popin",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.hidePopin,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        return _vm.hidePopin($event)
      }
    }
  }, [_c('div', {
    staticClass: "popin-cross-container",
    on: {
      "click": _vm.hidePopin
    }
  }, [_c('div', {
    staticClass: "popin-cross"
  })]), _vm._v(" "), _vm._l((_vm.epigram.imagesManuscript), function(manuscript) {
    return _c('img', {
      attrs: {
        "src": manuscript.URL,
        "alt": _vm.epigram.title
      }
    })
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "notExist"
  }, [_c('p', [_vm._v("L'épigramme que vous cherchez n'existe pas")]), _vm._v(" "), _c('back-btn')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "problem"
  }, [_c('p', [_vm._v("Un problème est survenu.")]), _vm._v(" "), _c('back-btn')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "carousel__header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-1"
  }, [_c('div', {
    staticClass: "text-theme"
  }, [_c('h3', [_vm._v("\n                  Références\n                ")])])])])])
}]}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-nav"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.listItems), function(listItem, index) {
    return _c('li', {
      directives: [{
        name: "track-by",
        rawName: "v-track-by",
        value: (index),
        expression: "index"
      }],
      staticClass: "index-list",
      on: {
        "mouseover": _vm.addClass
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.routeName,
          params: {
            parcoursId: _vm.itemId,
            epigramIndex: index + 1
          }
        }
      }
    }, [_c('span', {
      staticClass: "dash"
    }, [_c('span', {
      staticClass: "inner-dash"
    })]), _vm._v("\n                " + _vm._s(listItem.title) + "\n                "), _c('sup', [_vm._v(_vm._s(_vm._f("romanize")(index + 1)))])])], 1)
  }))])])
},staticRenderFns: []}

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[21]);


// WEBPACK FOOTER //
// static/js/app.2e619752bd55d81eef13.js